/**
 * Quote Email Template
 * Generates HTML email for quotes
 */

import type { QuoteData } from '@/shared/types';

export function generateQuoteEmail(quoteData: QuoteData): string {
  const { clientName, items, totalAmount, quoteNumber, currency, validUntil } = quoteData;

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Quote from SwaySuite</title>
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { background: #4f46e5; color: white; padding: 20px; border-radius: 8px 8px 0 0; }
        .content { background: #f9fafb; padding: 20px; border-radius: 0 0 8px 8px; }
        .table { width: 100%; border-collapse: collapse; margin-top: 20px; }
        .table th { background: #4f46e5; color: white; padding: 10px; text-align: left; }
        .table td { padding: 10px; border-bottom: 1px solid #e5e7eb; }
        .total { margin-top: 20px; font-size: 18px; font-weight: bold; text-align: right; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>Quote #${quoteNumber}</h1>
        </div>
        <div class="content">
          <p>Dear ${clientName},</p>
          <p>Thank you for your interest! Please find your quote below:</p>
          <p><strong>Valid Until:</strong> ${new Date(validUntil).toLocaleDateString()}</p>
          ${items && items.length > 0 ? `
            <table class="table">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                ${items.map(item => `
                  <tr>
                    <td>${item.description}</td>
                    <td>${currency} ${item.amount.toFixed(2)}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
            <div class="total">Total: ${currency} ${totalAmount.toFixed(2)}</div>
          ` : `
            <div class="total">Total: ${currency} ${totalAmount.toFixed(2)}</div>
          `}
        </div>
      </div>
    </body>
    </html>
  `;
}
